export default __webpack_public_path__ + "static/media/Gesture icons_Push-21.727360a7.svg";